import {css, StyleSheet} from "aphrodite";
import * as React from "react";

import Button from "@khanacademy/wonder-blocks-button";
import {View} from "@khanacademy/wonder-blocks-core";
import {Spring} from "@khanacademy/wonder-blocks-layout";
import {color} from "@khanacademy/wonder-blocks-tokens";
import {Title} from "@khanacademy/wonder-blocks-typography";
import {mediaQueries} from "@khan/shared-styles";
import {cssUrl} from "@khan/urls";

import {PAGE_WIDTH} from "./styles.ts";
import type {Images, Strings} from "./types.ts";

type Props = {
    strings: Strings;
    images: Images;
};

// This is a color specific to this page.
const BG_COLOR = "#ccfbf0";

export default class Hero extends React.Component<Props> {
    render(): React.ReactNode {
        const {strings, images} = this.props;

        return (
            <View style={styles.heroWrapper}>
                <Spring />
                <View style={styles.hero}>
                    <View style={styles.left}>
                        <Title style={styles.title}>{strings.title}</Title>
                        <View style={styles.ctaBtnWrapper}>
                            <Button href={strings.signupUrl}>
                                {strings.ctaGetStarted}
                            </Button>
                        </View>
                    </View>
                    <Spring />
                    <View style={styles.right}>
                        <div
                            className={css(styles.image)}
                            style={{
                                backgroundImage: cssUrl(images.hero),
                            }}
                        />
                    </View>
                </View>
                <Spring />
            </View>
        );
    }
}

const styles = StyleSheet.create({
    heroWrapper: {
        backgroundColor: BG_COLOR,
        width: "100%",
        alignItems: "center",
        flexDirection: "row",
    },
    hero: {
        flexBasis: PAGE_WIDTH,
        maxWidth: PAGE_WIDTH,
        flexDirection: "row",
        [mediaQueries.mdOrSmaller]: {
            marginLeft: 24,
            marginRight: 24,
        },
        [mediaQueries.smOrSmaller]: {
            flexDirection: "column",
        },
    },
    image: {
        width: 412,
        height: 316,
        borderRadius: 4,
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        [mediaQueries.mdOrSmaller]: {
            width: "100%",
            height: "100%",
        },
    },
    left: {
        paddingRight: 16,
        [mediaQueries.lgOrLarger]: {
            alignSelf: "center",
        },
        [mediaQueries.mdOrSmaller]: {
            marginTop: 48,
            maxWidth: 360,
        },
        [mediaQueries.smOrSmaller]: {
            marginBottom: 53,
            maxWidth: "100%",
        },
    },
    right: {
        minWidth: 412,
        marginTop: 48,
        marginBottom: 48,
        flexGrow: 0,
        [mediaQueries.mdOrSmaller]: {
            flexGrow: 1,
            minWidth: 310,
            minHeight: 238,
            marginTop: 32,
            marginBottom: 32,
        },
        [mediaQueries.smOrSmaller]: {
            display: "none",
        },
    },
    title: {
        color: color.darkBlue,
    },
    ctaBtnWrapper: {
        marginTop: 16,
        flexDirection: "row",
    },
});
